import { render } from "./TransferAnalytics.vue?vue&type=template&id=275e2380&scoped=true"
import script from "./TransferAnalytics.vue?vue&type=script&lang=js"
export * from "./TransferAnalytics.vue?vue&type=script&lang=js"

import "./TransferAnalytics.vue?vue&type=style&index=0&id=275e2380&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275e2380"],['__file',"resources/js/components/TransferAnalytics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "275e2380"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('275e2380', __exports__)) {
    api.reload('275e2380', __exports__)
  }
  
  module.hot.accept("./TransferAnalytics.vue?vue&type=template&id=275e2380&scoped=true", () => {
    api.rerender('275e2380', render)
  })

}


export default __exports__